import ButtonCreate from "./ButtonCreate";
import {handlerExport} from "../../../pages/common/settings/handlerExport";
import CircularProgress from "@mui/material/CircularProgress";
import React, {useState} from "react";
import {Box} from "@mui/system";

const ButtonExport = ({api, handleModalAlert, text, width, height = 38}) => {
    const [loading, setLoading] = useState(false)

    return <Box sx={{display: "flex", gap: "10px"}}>
        <ButtonCreate
            icon={false} text={text} width={width} height={height}
            onClick={() => handlerExport(api, handleModalAlert, setLoading)}
        />
        {loading && <CircularProgress size={30} disableShrink/>}
    </Box>
}
export default ButtonExport